// Import all system
require('./bootstrap');

// Gallery
const gallery = $('#gallery');

gallery.owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    responsive:{
        0:{
            items: 1
        },
        600:{
            items: 3
        },
        1000:{
            items: 5
        }
    }
});

$('.gallery-container .nav-next').click(function() {     
    gallery.trigger('next.owl.carousel');
});

$('.gallery-container .nav-prev').click(function() {
    gallery.trigger('prev.owl.carousel');
});

// Quotes
const quotes = $('#quotes');

quotes.owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    autoHeight: true,
    items: 1
});

// Wizard
$('.step-group .next-btn').click(function(e) {
    e.preventDefault();
    const $that = $(this);
    const group = $that.parents('.step-group');

    group.removeClass('active');
    group.next().addClass('active');
});

$('.step-group .prev-btn').click(function(e) {
    e.preventDefault();
    const $that = $(this);
    const group = $that.parents('.step-group');

    group.removeClass('active');
    group.prev().addClass('active');
});

$('.step-group .answer').click(function() {
    const $that = $(this);
    const group = $that.parents('.step-group');

    $(group).find('.next-btn').click();
});

// SWA
window.Swal = require('sweetalert2')

$('.swa-marketing').click(function(e) {
    e.preventDefault();
    Swal.fire({
        text: $(this).data('message')
    });
});

// Scroll
$(".scroll-to").click(function(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $( $(this).attr('href') ).offset().top
    }, 1000);
});